import { Component } from 'preact'
import likePostRequest from '../../utils/likePostRequest'
import Icon from '../assets/'
import { common } from '../common'
import Axios from 'axios'
import classNames from 'classnames'

export default class TopicListLikeButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      hasCurrentUserLiked: props.topic.hasCurrentUserLiked,
      numberOfLikes: props.topic.numberOfLikes
    }

    this.likeTopicHandler = this.likeTopicHandler.bind(this)
  }

  likeTopicHandler () {
    const { isGuest, topic } = this.props
    const { id } = topic.firstPost
    const { hasCurrentUserLiked, numberOfLikes } = this.state

    if (isGuest) {
      // eslint-disable-next-line no-undef
      const event = new CustomEvent('GuestUserAction')

      return window.dispatchEvent(event)
    }

    this.setState({
      hasCurrentUserLiked: !hasCurrentUserLiked,
      numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
    })

    if (topic.type === 'ideation' && common.isModuleActive('ideationV2')) {
      if (hasCurrentUserLiked) {
        Axios.post(`/community/api/ideas/${topic.privateId}/unvote`)
      } else {
        Axios.post(`/community/api/ideas/${topic.privateId}/vote`)
      }
    } else if (topic.contentType === 'productUpdate') {
      if (hasCurrentUserLiked) {
        Axios.post(`/community/api/productUpdates/${topic.privateId}/unlike`)
      } else {
        Axios.post(`/community/api/productUpdates/${topic.privateId}/like`)
      }
    } else {
      likePostRequest(topic.id, id, !hasCurrentUserLiked, (err) => {
        if (err) {
          this.setState({
            hasCurrentUserLiked: !hasCurrentUserLiked,
            numberOfLikes: parseInt(numberOfLikes, 10) + (!hasCurrentUserLiked ? 1 : -1)
          })
          console.error(err)
        }
      })
    }
  }

  render() {
    const { topic } = this.props
    const { hasCurrentUserLiked, numberOfLikes } = this.state

    const isIdeation = topic.type === 'ideation' || topic.forum.isIdeation
    
    let likeBtnClass = 'thread-meta-item thread-meta-item--hover-highlight thread-meta-item--likes qa-topic-meta-likes-icon'
    let voteBtnClass = 'thread-meta-item btn--toggle thread-meta-item--vote qa-topic-meta-likes-icon'

    if (hasCurrentUserLiked) {
      likeBtnClass += ' thread-meta-item--likes--liked'
      voteBtnClass += ' preact_voted'
    }

    return (
      !isIdeation
        ? (
          <button className={likeBtnClass} onClick={this.likeTopicHandler} type='button'>
            <i className={classNames('thread-meta-item__icon icon--auto-width', 'icon--thumb-up')} />
            <span className={classNames('thread-meta-item__text js-vote-count', 'qa-topic-meta-likes-content')}>
              {numberOfLikes}
            </span>
          </button>
          )
        : (
          <button className={voteBtnClass} onClick={this.likeTopicHandler}>
            <span className='qa-topic-meta-likes-content'>{numberOfLikes}</span>
            <Icon
              icon='triangle'
              width={10}
              height={8}
            />
          </button>
          )
    )
  }
}
